(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepagevideo"]) return;
  try {
    
function playHomepageVideo() {
  var video = document.getElementById("homepageVideo");
  var button = document.querySelector(".video-play-button");
  if (video) {
    video.play();
    button.style.display = "none";
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-vertical-mega-menu"]) return;
  try {
    
$("#init-toggle").click(function(){
    $(this).toggleClass('open');
    $(".vertical-mega-menu").toggleClass('open');    
  });

  jQuery(document).ready(function($) {  
   "use strict";    
     
       if($(window).width() <= 991) { 
      
      $("nav.vertical-mega-menu").each(function() {
  
        var vdata = $(this).data('vmenu'),                    
            ulData = $(this).find('ul[data-vmenu="' + vdata + '"]').clone().removeClass('dt-vnav'),
            vmobileData = $('body').find('.mobile-vmenu[data-vmenu="' + vdata + '"]');        

        console.log(ulData);
        // To Remove animation classes
        $('[data-animation]', ulData).each(function(ix, ele) {
          var $classes = $(ele).attr("class"),
              $animation = $(ele).attr("data-animation");
          $classes = $classes.replace($animation, '');
          $(ele).attr("class", $classes);
        });  
        ulData.prependTo(vmobileData);
      });
  
      VmobileTrigger();
  
      // Closing Mobile Nav
      $('li.v-close-nav').on('click', function(event) {
        VcloseMobNav();
      });
  
      $('body .vertical-mobile-menu-overlay').on('click', function(event) {
        VcloseMobNav();
      });
  
      // Sub Menu in Mobile Menu
      $('.v-mega-has-children > a').on('click', function(event) {
  
        if ($('body').hasClass('vnav-is-visible')) {
          event.preventDefault();
          var a = $(this).clone();
          $(this).next('.v-menu-sub').find('.see-all').html(a);          
        }
  
        var selected = $(this);                
        if (selected.next('div.v-menu-sub').hasClass('is-v-hidden')) {                    
          selected.addClass('selected').next('div.v-menu-sub').removeClass('is-v-hidden');
        } else {          
          selected.removeClass('selected').next('div.v-menu-sub').addClass('is-v-hidden');
        }
      });
  
      // Go Back in Mobile Menu
      $('.go-back').on('click', function() {        
        $(this).closest('div.v-menu-sub').addClass('is-v-hidden');
      });
    }
  

   function VmobileTrigger(){
      $('.vmenu-trigger').on('click', function(event) {    
        $('body').find('.mobile-vmenu').addClass('vnav-is-visible');
        $('body').find('.mobile-menu-overlay').addClass('is-showit');
        $('body').addClass('vnav-is-visible');        
      });  
    }
  
    function VcloseMobNav() {
      $('body').removeClass('vnav-is-visible');
      $('.vertical-mobile-menu-overlay').removeClass('is-showit');
      $('.mobile-vmenu').removeClass('vnav-is-visible');
      $('.v-mega-has-children a').removeClass('selected');
      $('.v-mega-has-children div.v-menu-sub').addClass('is-v-hidden');
    }
  
    $(window).on('resize',function() {
      VmobileTrigger();
      VcloseMobNav();          
    });
  
    $(window).on('load',function() {     
      VmobileTrigger();
      VcloseMobNav();  
    });

/* Tabs on Vertical navigation  */
    
 $(function() {
      if($(window).width() >= 992) {
         $('.from-vertical .tabs-nav a').click(function() {
         $(this).removeClass('active');
        $(this).parent().addClass('active');  
        let currentTab = $(this).attr('href');        
        $('.v-menu-sub .tabs-content li.dt-sc-menu-tabs').hide();
       console.log(currentTab);
        $(currentTab).show();
        return false;
      });
    }
      if($(window).width() < 992 ) { 
      $('.from-vertical .mobileTabs .tabs  li').each(function(){
        $(this).click(function(){        
          $(this).next('div').slideToggle(0);        
        });  
      })  
    }
    });    
});
  


  
  $('.level-has-child li.leavel-has-dropdown').click(function () {  
          $('li.leavel-has-dropdown').not(this).find('ul').hide();  
          $(this).find('ul').toggle();  
      });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // $('#play-video').on('click', function(e){
  //   e.preventDefault();
  //   $('#video-overlay').addClass('open');
  //   $("#video-overlay").append('<iframe width="560" height="315" src="https://www.youtube.com/embed/ngElkyQ6Rhs" frameborder="0" allowfullscreen></iframe>');
  // });

  // $('.video-overlay, .video-overlay-close').on('click', function(e){
  //   e.preventDefault();
  //   close_video();
  // });

  // $(document).keyup(function(e){
  //   if(e.keyCode === 27) { close_video(); }
  // });

  // function close_video() {
  //   $('.video-overlay.open').removeClass('open').find('iframe').remove();
  // };




    $( window ).on("load", function() {

      $( ".btn.play" ).each(function( index ) {
        $(this).on('click', function(){
          $(this).css('display','none');
          $(this).next('.btn.pause').css('display','flex');
          if($(this).parents('.video-cover').hasClass('swiper-slide-active')){
            $(this).parents('.video-cover').find('video').trigger('play');
          }
        });
      });

      $( ".btn.pause" ).each(function( index ) {
        $(this).on('click', function(){
          $(this).css('display','none');
          $(this).prev('.btn.play').css('display','flex');
          if($(this).parents('.video-cover').hasClass('swiper-slide-active')){
            $(this).parents('.video-cover').find('video').trigger('pause');
          }
        });
      });

      $('.swiper-button-next, .swiper-button-prev').on('click', function(){
        $(this).parents('.dt-sc-swiper-slider').find('video').trigger('pause');
        $(this).parents('.dt-sc-swiper-slider').find('.btn.pause').css('display','none');
        $(this).parents('.dt-sc-swiper-slider').find('.btn.play').css('display','flex');
      });

    });
      jQuery(document).ready(function($) {
      $('.slider-video').each(function () {
        var videoLink = $(this).find(".video_modal iframe").attr("src");
        var videoIcon = $(this).find('.video_icon');
        var videoBanner = $(this).closest('.video-banner-wrapper');
        var modal = $('.video_overlay');
        $video_modal = $('.video_overlay');
        // Make the entire red banner clickable (not just the play icon)
        videoBanner.on('click', function(e){
          // Only react to clicks on the banner itself (ignore clicks inside the modal)
          if ($(e.target).closest('.video_modal').length) return;
          videoIcon.trigger('click');
        });
        videoIcon.on('click',function(e) {
          e.preventDefault();
          e.stopPropagation();
          $video_modal.css('opacity', '1');
          $video_modal.css('visibility', 'visible');
          $video_modal.addClass('open');
          var dataModal = $('.video_player').attr("src", videoLink+"?&amp;autoplay=1");
          $video_modal.append(dataModal);
          disableScroll();
          e.preventDefault();
        });

        $('.close_icon, .video_overlay').on('click',function(e) {
          $(".video_player").attr("src", "");
          $video_modal.removeClass('open');
          $video_modal.css('opacity', '0');
          $video_modal.css('visibility', 'hidden');
          enableScroll();
          e.preventDefault();
        });

        window.onclick = function(event) {
          if (event.target == modal[0]) {
            $(".video_player").attr("src", "");
            $video_modal.removeClass('open');
            $video_modal.css('opacity', '0');
            $video_modal.css('visibility', 'hidden');
            enableScroll();
          }
        }
      });
    });
    function disableScroll() {
      // Get the current page scroll position
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,

        // if any scroll is attempted, set this to the previous value
        window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
      };
    }

    function enableScroll() {
      window.onscroll = function() {};
    }

  } catch(e) { console.error(e); }
})();
})();
